// The dependency-free coordinator is inlined before ALL styles and modules.
// All callers share its safe-reload checks and persistent per-build loop guard.
declare global {
  interface Window {
    __appRecovery?: {
      ready(): void;
      assetFailure(): void;
      addSafetyCheck(check: () => boolean | Promise<boolean>): void;
      checkVersion(): Promise<void>;
      isSafe(): Promise<boolean>;
    };
  }
}
export function isChunkLoadError(error: unknown): boolean {
  const value = error as { name?: string; message?: string } | null;
  return value?.name === "ChunkLoadError" ||
    /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading (CSS )?chunk|Unable to preload CSS|Cannot read propert(?:y|ies) of undefined \(reading 'default'\)|undefined is not an object \(evaluating '[^']*\.default'\)/i.test(String(value?.message ?? error ?? ""));
}
/** Compatibility entry point: NEVER bypass the form/queue safety coordinator. */
export function reloadOnce(_reason: string): boolean {
  window.__appRecovery?.ready();
  return !!window.__appRecovery;
}
export async function reloadForFreshShell(_reason: string): Promise<void> {
  window.__appRecovery?.assetFailure();
  try {
    const registration = await navigator.serviceWorker?.getRegistration();
    await registration?.update();
  } catch { /* Offline: the error panel remains usable; do not drop drafts. */ }
}
export function recoverFromStaleShell(_reason: string): () => void {
  // A real unknown URL is not evidence of a stale build. Only refresh when
  // the server reports a DIFFERENT release, not on every 404.
  void window.__appRecovery?.checkVersion();
  return () => {};
}
